<section fxLayout="column" fxLayoutGap="10px">
  <iot-platform-ui-detail-popup-section-header headerTitle="{{ 'DEVICES.DETAIL_POPUP.CONNECTORS' | translate }}"></iot-platform-ui-detail-popup-section-header>
  <iot-platform-ui-detail-device-card [context]="'connector'" [device]="device()"></iot-platform-ui-detail-device-card>
</section>
